import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";

const Styled = styled(Box)(({ theme }) => ({
  "& .MuiAlert-icon": { display: "none" },
  "& .gridItem": { textAlign: "center" },
  "& .warningText": {
    fontSize: "0.85rem",
    fontWeight: 500,
    lineHeight: 1.5,
    letterSpacing: 0.4,
    color: undefined,
    "& .MuiSvgIcon-root": {
      marginRight: "0.125rem",
      verticalAlign: "sub",
      fontSize: "0.95rem",
    },
    ...theme.applyStyles("light", { fontWeight: 700, color: "#31708f" }),
  },
  "& .message": {
    fontSize: "0.85rem",
    fontWeight: 400,
    lineHeight: 1.5,
    margin: "1rem",
    color: undefined,
    textAlign: "center",
    ...theme.applyStyles("light", { color: "#31708f" }),
  },
}));

export default Styled;
